import { render, staticRenderFns } from "./GameHome.vue?vue&type=template&id=29296354&scoped=true"
import script from "./GameHome.vue?vue&type=script&lang=js"
export * from "./GameHome.vue?vue&type=script&lang=js"
import style0 from "./GameHome.vue?vue&type=style&index=0&id=29296354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29296354",
  null
  
)

export default component.exports